//
//
//
//
//
//
//
//
//
//

import ListSeller from './Variants/ListSeller'

export default {
  name: 'ListCardUi',
  components: {
    ListSeller,
  },
  props: {
    isSempler: {
      default: false,
    },
    product: {
      default: () => { },
    },
    load: {},
    canRemove: {},
  },

  computed: {
    isSet() {
      return this.product.base.element.props.set
    },
    productProps() {
      const { relations, base, price } = this.product
      return {
        load: this.load,
        product: base,
        relations,
        price,
        disabled: this.$attrs.disabled,
        canRemove: this.canRemove,
      }
    },
  },
}
